import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncContactUs({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/contactUs"));
  console.log("Loading", AsyncContactUs.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncContactUs;
